module.exports = __webpack_public_path__ + "img/suggar-comments.3f09ccfd.webp";